import { withProtocol } from "ufo";

const cloudApiFallback = window.AXSHARE_HOST_SECURE_URL // use standalone base url if exists
  || window.location.origin;

/** Dev .env points at localhost; Brave blocks those from a non-localhost document. Use the page hostname instead. */
function rewriteLocalhostDevUrl(url: string, pageOrigin: string): string {
  let pageHost: string;
  try {
    pageHost = new URL(pageOrigin).hostname;
  } catch {
    return url;
  }
  if (pageHost === "localhost" || pageHost === "127.0.0.1") {
    return url;
  }
  try {
    const u = new URL(url);
    if (u.hostname === "localhost" || u.hostname === "127.0.0.1") {
      u.hostname = pageHost;
    }
    return u.toString();
  } catch {
    return url;
  }
}

// In dev, VITE_CLOUD_API_URL is usually https://localhost:44300 from .env, which breaks hosts-file /
// custom-domain setups (page origin is e.g. https://martin.axuretest.com:44300). Same-origin as the MVC host.
export const cloudApiUrl = import.meta.env.DEV
  ? cloudApiFallback
  : (import.meta.env.VITE_CLOUD_API_URL || cloudApiFallback);

export const serverApiUrl = import.meta.env.DEV
  ? rewriteLocalhostDevUrl(import.meta.env.VITE_DISKO_SERVER_URL, cloudApiFallback)
  : new URL("api/disko/", cloudApiFallback).toString();

export const textServiceUrl = import.meta.env.DEV
  ? rewriteLocalhostDevUrl(import.meta.env.VITE_DISKO_TEXT_SERVICE_URL, cloudApiFallback)
  : new URL("api/disko/text-service/", cloudApiFallback).toString();

export const textServiceWSUrl = import.meta.env.DEV
  ? withProtocol(textServiceUrl, "ws://")
  : withProtocol(textServiceUrl, import.meta.env.PROD ? "wss://" : "ws://");
